import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mis-graduaciones',
  templateUrl: './mis-graduaciones.component.html',
  styleUrls: ['./mis-graduaciones.component.css']
})
export class MisGraduacionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
